/**
 * Shared colour grade for every landscape photograph, so stock images of
 * different origins read as one warm, hazy, golden-green set.
 */
export const PHOTO_GRADE = 'saturate-[.86] sepia-[.16] contrast-[1.06] brightness-[.74]'

/** Softer grade for portraits before their colour wash is applied. */
export const PORTRAIT_GRADE = 'grayscale-[.3] sepia-[.12] contrast-[1.05] brightness-[.94]'

export const LANDSCAPES = {
    heroHills: '/images/landscapes/hero-hills.jpg',
    mistyRidges: '/images/landscapes/misty-ridges.jpg',
    windingPath: '/images/landscapes/winding-path.jpg',
    grassBlur: '/images/landscapes/grass-blur.jpg',
    wheatHaze: '/images/landscapes/wheat-haze.jpg',
    wheatField: '/images/landscapes/wheat-field.jpg',
    tallGrassFigure: '/images/landscapes/tall-grass-figure.jpg',
    fieldDusk: '/images/landscapes/field-dusk.jpg',
    pampas: '/images/landscapes/pampas.jpg',
    goldenTree: '/images/landscapes/golden-tree.jpg',
    hillTree: '/images/landscapes/hill-tree.jpg',
    wildflowers: '/images/landscapes/wildflowers.jpg',
    cypressVilla: '/images/landscapes/cypress-villa.jpg',
    loneTree: '/images/landscapes/lone-tree.jpg',
    meadowBlur: '/images/landscapes/meadow-blur.jpg',
    seedHeads: '/images/landscapes/seed-heads.jpg',
    poppyMeadow: '/images/landscapes/poppy-meadow.jpg'
} as const

export type LandscapeKey = keyof typeof LANDSCAPES
